module.exports = __webpack_public_path__ + "img/1.944b52f9.png";